import React from "react";
import { useEffect } from "react";
import { useUser } from "../Contexts/UserContext";
import { API_URL } from "../Helpers/api";

const Auth = () => {
  const { loading } = useUser();

  useEffect(() => {
    window.location.href = `${API_URL}/auth/google`;
  }, []);

  if (loading) {
    return (
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }

  return <div></div>;
};

export default Auth;
